import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

export type TUploadFileChunkParams = {
  cnmcId: string;
  fileId: string;
  file: Blob;
  partNumber: number;
  signal?: AbortSignal;
  onUploadProgress?: (progressEvent: AxiosProgressEvent) => void;
};

export type TUploadFileChunkResponse = {
  file_id: string;
  etag: string;
};

export async function uploadFileChunk({
  cnmcId,
  fileId,
  file,
  partNumber,
  signal,
  onUploadProgress,
}: TUploadFileChunkParams): Promise<TUploadFileChunkResponse> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('part_number', partNumber.toString());

  return mediaManagerClient.post(`/api/v1/cnmcs/${cnmcId}/files/${fileId}/chunk`, formData, {
    signal,
    timeout: 0,
    onUploadProgress,
  });
}

type MutationFn = typeof uploadFileChunk;

type TUseUploadFileChunkParams = {
  config?: MutationConfig<MutationFn>;
};

export function useUploadFileChunk({ config = {} }: TUseUploadFileChunkParams = {}) {
  return useMutation({
    ...config,
    mutationFn: uploadFileChunk,
    onError(error) {
      console.error(error);
    },
  });
}
